import { cx } from "class-variance-authority";
import type { ReactNode } from "react";

import { useDragToScroll } from "../hooks/useDragToScroll";
import { useScrollBoundary } from "../hooks/useScrollBoundary";

import * as styles from "./OverflowText.module.scss";

type OverflowTextProps = {
  children: ReactNode;
  className?: string;
};

const OverflowText = ({ children, className }: OverflowTextProps) => {
  const { ref, isStart, isEnd, isScrollable } = useScrollBoundary("horizontal");
  const isDragging = useDragToScroll(ref, isScrollable);

  return (
    <div
      className={cx(
        styles.root,
        {
          [styles.fadeStart]: isScrollable && !isStart,
          [styles.fadeEnd]: isScrollable && !isEnd,
        },
        className,
      )}
    >
      <div
        ref={ref}
        className={cx(styles.scroller, {
          [styles.grab]: isScrollable,
          [styles.dragging]: isDragging,
        })}
      >
        {children}
      </div>
    </div>
  );
};

OverflowText.displayName = "OverflowText";

export { OverflowText };
